/* Gardenmac — configuratore e test prodotto. Generato da .brief/configuratore-v2-2026-10-09/lavoro/crea-bundle.py: non modificare qui. */
(() => {
const VERSION = "2026-10-10.4";
const colture = [
  "Uliveto",
  "Vigneto",
  "Agrumeto — aranci",
  "Agrumeto — limoni",
  "Agrumeto — mandarini e altri agrumi",
  "Meleto",
  "Pereto",
  "Pescheto",
  "Albicoccheto",
  "Ciliegeto",
  "Susineto",
  "Mandorleto",
  "Noccioleto",
  "Castagneto",
  "Actinidieto — kiwi",
  "Giardino e manutenzione del verde",
  "Altra coltura — legno tenero",
  "Altra coltura — legno di media durezza",
  "Altra coltura — legno duro",
];
const categorie = (c) =>
  c === "Uliveto"
    ? "ulivo"
    : c === "Vigneto"
      ? "vigneto"
      : c.startsWith("Agrumeto")
        ? "agrumeto"
        : c.startsWith("Altra coltura")
          ? "altra"
          : c.startsWith("Giardino")
            ? "giardino"
            : "frutteto";
const domande = {
  lavorazione: [
    "Potatura con forbici",
    "Potatura con potatore a catena",
    "Legatura",
    "Raccolta delle olive",
  ],
  modalitaForbici: [
    "Solo forbice, senza asta",
    "Con asta, per raggiungere i rami alti da terra",
    "Sia senza asta sia con asta",
  ],
  modalitaPotatori: [
    "Solo potatore a catena, senza asta",
    "Con asta, per raggiungere i rami alti da terra",
    "Sia senza asta sia con asta",
  ],
  usoUlivo: [
    "Hobbistico",
    "Semiprofessionale fino a 500 piante",
    "Semiprofessionale fino a 1.000 piante",
    "Professionale",
  ],
  uso: [
    "Hobbistico",
    "Semiprofessionale",
    "Professionale",
    "Professionale intensivo",
  ],
  diametroForbici: [
    "Meno di 30 mm",
    "Da 30 a 35 mm",
    "Oltre 35 e fino a 40 mm",
    "Oltre 40 e fino a 45 mm",
  ],
  diametroPotatori: [
    "Meno di 10 cm",
    "Da 10 a 15 cm",
    "Diametri variabili e imprevedibili, anche oltre 15 cm",
  ],
  alimentazione: [
    "Batteria sotto la forbice",
    "Batteria separata con cavo",
    "Entrambe",
    "Nessuna preferenza",
  ],
  priorita: [
    "Peso contenuto e maneggevolezza",
    "Velocità nei tagli ripetuti",
    "Robustezza per lavoro continuativo",
    "Maggiore capacità di taglio",
    "Prestazioni top di gamma",
  ],
};
const rows = [
  ["swansoft-sw-718-28mm", 28, "hobby", "pulizia", false],
  ["swansoft-8605", 40, "hobby", "misto", true],
  ["forbici-swansoft-pru-28", 28, "pro", "pulizia", false],
  ["swansoft-pru-30", 30, "pro", "vigneto", true],
  ["forbici-falco-titan-30", 30, "pro", "vigneto", false],
  ["forbici-swansoft-8608-35mm", 35, "semi", "misto", true],
  ["swansoft-pru-36", 36, "pro", "misto", true],
  ["forbice-falco-evo-1", 35, "top", "frutteto", true],
  ["swansoft-8605-pro", 40, "semi500", "ulivo", true],
  ["swansoft-sw-758-40mm", 40, "semi1000", "ulivo", true],
  ["forbice-swansoft-pru-40mm", 40, "pro", "ulivo", true],
  ["forbice-falco-titan-40", 40, "pro", "ulivo", true],
  ["forbici-falco-evo-2", 40, "top", "ulivo", true],
  ["forbici-falco-evo-3", 42, "top", "frutteto", true],
  ["forbici-swansoft-sw-768-42mm", 42, "pro", "doppia_lama", true],
  ["forbice-swansoft-pru-45-plus", 45, "pro", "misto", true],
  ["forbici-falco-titan-45", 45, "pro", "misto", true],
];
const catalogoForbici = rows.map(
  ([handle, capacita, livello, uso, asta]) => ({
    handle,
    capacita,
    livello,
    uso,
    asta,
  }),
);

const modelli = {
  sw718: "swansoft-sw-718-28mm",
  hobby40: "swansoft-8605",
  pru28: "forbici-swansoft-pru-28",
  pru30: "swansoft-pru-30",
  titan30: "forbici-falco-titan-30",
  sw8608: "forbici-swansoft-8608-35mm",
  pru36: "swansoft-pru-36",
  evo1: "forbice-falco-evo-1",
  pro8605: "swansoft-8605-pro",
  sw758: "swansoft-sw-758-40mm",
  pru40: "forbice-swansoft-pru-40mm",
  titan40: "forbice-falco-titan-40",
  evo2: "forbici-falco-evo-2",
  evo3: "forbici-falco-evo-3",
  sw768: "forbici-swansoft-sw-768-42mm",
  plus45: "forbice-swansoft-pru-45-plus",
  titan45: "forbici-falco-titan-45",
  sw921: "svettatoio-swansoft-sw-921",
  cs1se: "potatore-swansoft-cs-1-se-6",
  cs1: "potatore-swansoft-cs-1-6",
  cs26: "potatore-swansoft-cs-2-6",
  cs28: "potatore-cs-2-8",
  xpro: "potatore-falco-x-pro",
  cs10: "potatore-swansoft-cs-10",
  skycut: "potatore-falco-skycut-315",
  b12: "legatrice-a-batteria-swansoft-swb12",
  evo42: "abbacchiatore-falco-evo42",
  evo42ultra: "abbacchiatore-falco-evo-42-ultra",
};
const nomiModelli = {
  sw718: "SW-718",
  hobby40: "8605",
  pru28: "PRU-28",
  pru30: "PRU-30",
  titan30: "Titan 30",
  sw8608: "8608",
  pru36: "PRU-36",
  evo1: "EVO 1",
  pro8605: "8605 Pro",
  sw758: "SW-758",
  pru40: "PRU-40",
  titan40: "Titan 40",
  evo2: "EVO 2",
  evo3: "EVO 3",
  sw768: "SW-768",
  plus45: "PRU-45 PLUS",
  titan45: "Titan 45",
  sw921: "SW-921",
  cs1se: "CS-1 SE",
  cs1: "CS-1",
  cs26: "CS-2 da 6 pollici",
  cs28: "CS-2 da 8 pollici",
  xpro: "X-PRO",
  cs10: "CS-10",
  skycut: "Skycut 315",
  b12: "B12",
  evo42: "EVO 42",
  evo42ultra: "EVO 42 Ultra",
};
const ETICHETTE_PRIORITA = {
  peso: "Peso contenuto e maneggevolezza",
  velocita: "Velocità nei tagli ripetuti",
  robustezza: "Robustezza per lavoro continuativo",
  capacita: "Maggiore capacità di taglio",
  top: "Prestazioni top di gamma",
  compattezza: "Corpo compatto e accorciato",
};
const famiglieBatterie = [
  ["pru28", "sw718", "cs1se"],
  ["sw8608", "pru30", "pru36", "cs1", "b12"],
  [
    "sw758",
    "sw768",
    "pru40",
    "evo1",
    "pro8605",
    "cs26",
    "cs28",
    "xpro",
    "cs10",
    "skycut",
  ],
  ["plus45", "evo2", "evo3", "sw921"],
  ["titan40", "titan45"],
];
const datiExtra = [
  ["sw921", 40, "forbici", false, true],
  ["cs1se", 120, "potatori", false, false],
  ["cs1", 130, "potatori", true, false],
  ["cs26", 130, "potatori", true, false],
  ["cs28", 190, "potatori", true, false],
  ["xpro", 200, "potatori", false, false],
  ["cs10", 190, "potatori", false, true],
  ["skycut", 200, "potatori", false, true],
];
const prodotti = Object.fromEntries([
  ...catalogoForbici.map((x) => [
    Object.keys(modelli).find((k) => modelli[k] === x.handle),
    {
      ...x,
      famiglia: "forbici",
      fissa: false,
      cavo: ![
        "swansoft-sw-718-28mm",
        "forbici-swansoft-pru-28",
        "forbici-falco-titan-30",
      ].includes(x.handle),
    },
  ]),
  ...datiExtra.map(([id, capacita, famiglia, asta, fissa]) => [
    id,
    {
      handle: modelli[id],
      capacita,
      famiglia,
      asta,
      fissa,
      cavo: id === "sw921",
    },
  ]),
]);
function compatibili(id) {
  return (famiglieBatterie.find((g) => g.includes(id)) || [])
    .filter((k) => k !== id)
    .map((k) => ({
      id: k,
      handle: modelli[k] || null,
      famiglia: k === "b12" ? "legatura" : prodotti[k]?.famiglia,
    }));
}
function gruppoColtura(c) {
  if (c === "Uliveto" || c === "Altra coltura — legno di media durezza")
    return "ulivo";
  if (
    [
      "Noccioleto",
      "Mandorleto",
      "Castagneto",
      "Pescheto",
      "Albicoccheto",
      "Ciliegeto",
      "Susineto",
      "Altra coltura — legno duro",
    ].includes(c)
  )
    return "duro";
  if (c === "Vigneto") return "vigneto";
  if (c === "Altra coltura — legno tenero") return "tenero";
  if (c?.startsWith("Giardino")) return "giardino";
  return "frutteto";
}
function vincoli(id, a) {
  const p = prodotti[id],
    errors = [];
  if (!p) return ["Modello non mappato"];
  if (a.famiglia !== p.famiglia)
    errors.push("Famiglia diversa da quella richiesta");
  if (Number(a.diametro) > p.capacita)
    errors.push(
      "La capacità indicativa non copre il diametro massimo richiesto",
    );
  const asta = a.modalita && a.modalita !== "senza";
  if (asta && a.tipoAsta === "fissa" && !p.fissa)
    errors.push("Non è un modello con asta fissa");
  if (asta && a.tipoAsta !== "fissa" && !p.asta)
    errors.push("Non compatibile con asta smontabile");
  if (!asta && p.fissa) errors.push("Modello con asta fissa");
  if (
    a.famiglia === "forbici" &&
    ["cavo", "entrambe"].includes(a.alimentazione) &&
    !p.cavo
  )
    errors.push("Non alimentabile tramite cavo");
  return errors;
}
function consiglia(a, catalogo = []) {
  const manca = (richiesta) => ({
    stato: "incompleto",
    richiesta,
    versione: VERSION,
  });
  const approfondisci = (richiesta) => ({
    stato: "da_precisare",
    richiesta,
    versione: VERSION,
  });
  if (!a.colture?.length) return manca("colture");
  if (a.colture.length > 1 && !a.prevalente) return manca("prevalente");
  if (a.prevalente && !a.colture.includes(a.prevalente))
    return manca("prevalente");
  let g = gruppoColtura(a.prevalente || a.colture[0]);
  if (g === "tenero" && a.tipoLegnoTenero) g = a.tipoLegnoTenero;
  const primaria = a.prioritaPrincipale || a.priorita?.[0] || "nessuna";
  // La principale prevale sempre. La secondaria conta solo dove la principale
  // non distingue i modelli di quel ramo (es. «capacità» fra due 40 mm): ogni
  // ramo dichiara le priorita' che lo fanno cambiare.
  let secondariaUsata = null;
  const prio = (decisive) => {
    if (decisive.includes(primaria)) return primaria;
    const sec = a.prioritaSecondaria;
    if (sec && sec !== "nessuna" && decisive.includes(sec)) {
      secondariaUsata = sec;
      return sec;
    }
    return "nessuna";
  };
  const semi = ["semi", "semi500", "semi1000", "regolare"].includes(a.livello);
  const hobby = ["hobby", "occasionale"].includes(a.livello);
  const d = Number(a.diametro),
    cable = ["cavo", "entrambe"].includes(a.alimentazione);
  let ids = [],
    motivo = "",
    regola = "",
    avvertenze = [];
  const scelta = (r, i, m) => {
    regola = r;
    ids = i;
    motivo = m;
  };
  const grandi = () => {
    const titan = ["compattezza", "peso", "robustezza"].includes(
      prio(["compattezza", "peso", "robustezza", "velocita"]),
    );
    scelta(
      "forbici45",
      titan ? ["titan45", "plus45"] : ["plus45", "titan45"],
      titan
        ? "Titan 45: la 45 mm con il corpo accorciato e il pignone maggiorato, per i tagli in cui una 40 o una 42 non basta."
        : "PRU-45 PLUS: copre i tagli in cui una 40 o una 42 non basta, con la priorità alla reattività.",
    );
  };
  if (a.famiglia === "raccolta") {
    if (!a.alimentazioneRaccolta) return manca("alimentazioneRaccolta");
    if (!a.livello) return manca("livello");
    const pref = a.alimentazioneRaccolta;
    const ultra = pref === "zaino" || (pref === "nessuna" && !hobby && !semi);
    const id = ultra ? "evo42ultra" : "evo42",
      alt = ultra ? "evo42" : "evo42ultra";
    const motivazione =
      pref === "zaino"
        ? "EVO 42 Ultra, perché preferisci la batteria nello zaino: porti l’alimentazione con te e ti sposti tra le piante senza dipendere da una batteria a terra."
        : pref === "terra"
          ? "EVO 42, perché preferisci la batteria a terra con il cavo: niente peso sulle spalle, e va bene anche per il professionista che lavora così."
          : ultra
            ? "EVO 42 Ultra, per un lavoro professionale e intensivo: con la batteria nello zaino passi giornate intere tra le piante senza dipendere da una batteria a terra."
            : "EVO 42, per un uso personale o meno intenso: spendi meno e non porti peso sulle spalle.";
    return {
      stato: "consiglio",
      versione: VERSION,
      regola: pref === "nessuna" ? "raccolta_livello" : "raccolta_preferenza",
      principaleId: id,
      principale: modelli[id],
      alternative: [modelli[alt]],
      alternativeId: [alt],
      motivazione,
      avvertenze:
        id === "evo42"
          ? [
              "EVO 42 si alimenta da una batteria per auto da 12 V e almeno 70 Ah.",
            ]
          : [],
      compatibili: [],
      richiedeHandle: false,
    };
  }
  if (a.famiglia === "legatura") {
    if (!(a.diametroLegatura > 0)) return manca("diametroLegatura");
    return Number(a.diametroLegatura) > 25
      ? {
          stato: "fuori_gamma",
          richiesta: "Il diametro complessivo di ramo e sostegno supera 25 mm.",
        }
      : {
          stato: "consiglio",
          versione: VERSION,
          principaleId: "b12",
          principale: modelli.b12,
          alternative: [],
          alternativeId: [],
          regola: "legatura25",
          avvertenze: [],
          motivazione:
            "B12 per la legatura, entro 25 mm complessivi di ramo e sostegno.",
          compatibili: compatibili("b12"),
          richiedeHandle: false,
        };
  }
  if (!["forbici", "potatori"].includes(a.famiglia)) return manca("famiglia");
  if (!(d > 0)) return manca("diametro");
  if (!a.livello) return manca("livello");
  if (
    a.prioritaSecondaria &&
    a.prioritaSecondaria === primaria &&
    primaria !== "nessuna"
  )
    return manca("prioritaSecondaria");
  if (
    a.modalita &&
    a.modalita !== "senza" &&
    a.famiglia === "potatori" &&
    !a.tipoAsta
  )
    return manca("tipoAsta");
  if (a.famiglia === "forbici") {
    if (d > 45)
      return {
        stato: "fuori_gamma",
        richiesta: "Nessuna forbice della gamma copre il diametro richiesto.",
      };
    if (a.tipoAsta === "fissa" && a.modalita !== "senza")
      scelta(
        "asta_fissa",
        ["sw921"],
        "SW-921, perché cerchi espressamente una forbice con l’asta fissa.",
      );
    else if (a.movimento === "sincronizzato" && g !== "ulivo" && d >= 35 && d <= 42) {
      // Preferenza espressa: SW-768 davanti. L'alternativa e' quello che il
      // percorso darebbe con il movimento tradizionale, cosi' il confronto
      // A/B dice cosa cambia davvero rinunciando alla preferenza.
      const tradizionale = consiglia(
        { ...a, movimento: "tradizionale" },
        catalogo,
      );
      const alt =
        tradizionale.stato === "consiglio" &&
        tradizionale.principaleId !== "sw768"
          ? [tradizionale.principaleId]
          : [];
      scelta(
        "movimento_sincronizzato",
        ["sw768", ...alt],
        "SW-768, perché preferisci una forbice con entrambe le lame mobili: una sola lama tagliente e un taglio pronto, fino a 42 mm.",
      );
    } else if (d > 40) {
      // Hobby oltre i 40 mm: la PRU-45 PLUS costa meno della EVO 3 e taglia di
      // piu' (Jacopo, 10/10/2026: mai il top di gamma a chi pota per hobby).
      if (hobby) grandi();
      else if (g !== "ulivo" && g !== "giardino" && d <= 42)
        scelta(
          "frutteto42",
          ["evo3", "plus45"],
          "EVO 3: il top di gamma che arriva a 42 mm, per tagli impegnativi e uso intensivo.",
        );
      else if (
        g !== "ulivo" &&
        g !== "giardino" &&
        a.oltre42 === "occasionali"
      ) {
        scelta(
          "frutteto42_occasionali",
          ["evo3", "plus45"],
          "EVO 3 per i tagli abituali entro 42 mm; la PRU-45 PLUS è la scelta per coprire anche i tagli più grandi.",
        );
        avvertenze.push(
          "EVO 3 arriva a 42 mm e non copre i tagli occasionali oltre questo diametro.",
        );
      } else if (g !== "ulivo" && g !== "giardino" && !a.oltre42)
        return manca("oltre42");
      else grandi();
    } else if (a.intervento === "pulizia" && d <= 28) {
      if (cable) {
        scelta(
          "pulizia_cavo",
          ["pru30"],
          "PRU-30, perché vuoi il cavo: la forbice specifica per polloni e succhioni è la PRU-28, che però non si alimenta con il cavo. La PRU-30 è la più vicina.",
        );
      } else if (a.modalita && a.modalita !== "senza")
        return approfondisci(
          "Per la pulizia con l’asta non abbiamo una forbice specifica: dipende dalla potatura che fai con la stessa forbice. Scrivici e ti aiutiamo a scegliere.",
        );
      else
        scelta(
          "pulizia",
          hobby ? ["sw718"] : ["pru28"],
          hobby
            ? "SW-718 per la pulizia in giardino: polloni, succhioni e tagli sottili, senza asta e senza cavo."
            : "PRU-28 per la pulizia frequente di polloni e succhioni: è la forbice di supporto per tanti piccoli tagli ripetuti.",
        );
    } else if (hobby)
      scelta(
        "hobby40",
        ["hobby40"],
        "8605: la forbice hobbistica per la potatura varia, con apertura fino a 40 mm.",
      );
    else if (g === "ulivo") {
      if (semi) {
        const p = prio(["top", "velocita"]);
        if (p === "top")
          scelta(
            "ulivo_semi_upgrade",
            ["pru40", "sw758"],
            "PRU-40, perché chiedi prestazioni da professionale; SW-758 resta l’alternativa semiprofessionale.",
          );
        else if (a.livello === "semi1000")
          scelta(
            "ulivo_semi1000",
            ["sw758", "pru40"],
            "SW-758 per un oliveto semiprofessionale fino a 1.000 piante, con tagli fino a 40 mm.",
          );
        else if (p === "velocita")
          scelta(
            "ulivo_semi_velocita",
            ["sw758", "pro8605"],
            "SW-758, perché hai messo la velocità al primo posto: è più reattiva della 8605 Pro.",
          );
        else
          scelta(
            "ulivo_semi500",
            ["pro8605", "sw758"],
            "8605 Pro per un uso semiprofessionale fino a 500 piante; SW-758 è l’alternativa più reattiva.",
          );
      } else {
        const p = prio([
          "peso",
          "robustezza",
          "top",
          "compattezza",
          "velocita",
        ]);
        if (p === "peso" || p === "robustezza")
          scelta(
            "ulivo_pro_titan",
            ["titan40", "pru40"],
            p === "peso"
              ? "Titan 40, perché conta il peso: a parità di potenza con la PRU-40, le batterie sono più leggere."
              : "Titan 40, perché conta la robustezza: il pignone maggiorato è pensato per durare nel lavoro continuativo.",
          );
        else if (p === "top" || p === "compattezza")
          scelta(
            "ulivo_top",
            p === "compattezza" ? ["evo2", "titan40"] : ["evo2", "pru40"],
            "EVO 2: il top di gamma da 40 mm, con corpo compatto, accorciato e alleggerito e struttura insonorizzata.",
          );
        else
          scelta(
            "ulivo_pro",
            ["pru40", "titan40"],
            "PRU-40: il riferimento più scelto dai professionisti per la potatura dell’uliveto, pronta e veloce.",
          );
      }
    } else if (g === "duro") {
      if (semi && d <= 35)
        scelta(
          "duro_semi35",
          ["sw758", "pru40"],
          "SW-758 per il semiprofessionista; PRU-40 per passare al professionale.",
        );
      else if (semi)
        scelta(
          "duro_semi40",
          ["pru40", "plus45"],
          "PRU-40 per tagli impegnativi entro 40 mm; PRU-45 PLUS se serve maggiore apertura.",
        );
      else if (d <= 35)
        scelta(
          "duro_pro35",
          ["pru40", "titan40"],
          "PRU-40 per tagli impegnativi su queste colture; Titan 40 a parità di prestazioni, con batterie più leggere e pignone maggiorato.",
        );
      else
        scelta(
          "duro_pro40",
          ["titan40", "evo3"],
          "Titan 40 per tagli fino a 40 mm su legno duro, nel lavoro di tutti i giorni: pignone maggiorato e batterie più leggere; EVO 3 se vuoi il top di gamma, con margine fino a 42 mm.",
        );
    } else if (g === "vigneto" && d <= 30) {
      if (semi)
        scelta(
          "vigneto_semi",
          ["sw8608", "pru30"],
          "8608 per uso semiprofessionale; PRU-30 per il passaggio al professionale nel vigneto.",
        );
      else {
        const p = prio(["peso", "velocita", "compattezza"]);
        scelta(
          "vigneto_pro",
          p === "peso" ? ["titan30", "pru30"] : ["pru30", "titan30"],
          p === "peso"
            ? "Titan 30, perché conta il peso: è la più leggera per il lavoro nel vigneto. PRU-30 resta l’alternativa."
            : "PRU-30 per velocità, poco ingombro e tagli ripetuti nel vigneto.",
        );
      }
    } else if (g === "tenero" && d < 30)
      return approfondisci(
        "Legno tenero sotto 30 mm: precisare la coltura o l’intervento per distinguere vigneto, frutteto e pulizia.",
      );
    else if (d <= 35) {
      if (semi && d <= 30 && g === "frutteto")
        scelta(
          "frutteto_semi30",
          ["pru30", "sw8608"],
          "PRU-30 per tagli fino a 30 mm: la più veloce del catalogo, per tanti tagli piccoli e ripetuti; 8608 è l’alternativa semiprofessionale.",
        );
      else if (semi) {
        const top = prio(["top"]) === "top";
        scelta(
          "frutteto_semi",
          top ? ["pru36", "sw8608"] : ["sw8608", "pru36"],
          top
            ? "PRU-36, perché chiedi prestazioni da professionale; 8608 resta l’alternativa semiprofessionale."
            : "8608 per un uso semiprofessionale; PRU-36 per passare al professionale.",
        );
      } else if (
        g === "vigneto" ||
        g === "giardino" ||
        a.colture.some((c) => gruppoColtura(c) === "ulivo")
      )
        scelta(
          "misto35",
          ["pru36", "evo1"],
          "PRU-36: la professionale intermedia e versatile, per passare da una coltura all’altra; EVO 1 come alternativa top di gamma.",
        );
      else if (["peso", "velocita"].includes(prio(["peso", "velocita"])))
        scelta(
          "frutteto35_pru36",
          ["pru36", "evo1"],
          "PRU-36: pronta e maneggevole per i tagli ripetuti fino a 36 mm; EVO 1 è l’alternativa top di gamma.",
        );
      else
        scelta(
          "frutteto35",
          ["evo1", "pru36"],
          "EVO 1: il top di gamma entro 35 mm, leggera e potente; PRU-36 è l’alternativa professionale versatile.",
        );
    } else if (d <= 36)
      // Fascia 35-40 con taglio massimo a 36 mm (questione aperta 2): prima
      // diventava 40 e la PRU-36 restava fuori proprio dove serve.
      scelta(
        "fascia36",
        semi ? ["pru36"] : ["pru36", "evo3"],
        "PRU-36: arriva a 36 mm, cioè copre il taglio più grosso che hai indicato, oltre i 35 mm di 8608 ed EVO 1." +
          (semi
            ? ""
            : " EVO 3 se vuoi il top di gamma, con margine fino a 42 mm."),
      );
    else if (g === "vigneto")
      // Vigneto fino a 40 mm (Jacopo, 10/10/2026).
      scelta(
        "vigneto40",
        semi ? ["sw758", "pru40"] : ["pru40", "titan40"],
        semi
          ? "SW-758 per tagli fino a 40 mm con un uso semiprofessionale; PRU-40 per passare al professionale."
          : "PRU-40 per tagli fino a 40 mm nel lavoro di tutti i giorni; Titan 40 a parità di prestazioni, con batterie più leggere.",
      );
    else if (g === "giardino")
      scelta(
        "giardino40",
        ["pru40", "plus45"],
        "PRU-40 per tagli entro 40 mm; PRU-45 PLUS per maggiore capacità.",
      );
    else
      // Jacopo, 10/10/2026: a 40 mm la PRU-40 davanti, la EVO 3 come salto al top.
      scelta(
        "frutteto40",
        semi ? ["pru40", "titan40"] : ["titan40", "evo3"],
        semi
          ? "PRU-40 per tagli fino a 40 mm: la professionale più scelta, un passo sopra le semiprofessionali; Titan 40 a parità di prestazioni, con batterie più leggere."
          : "Titan 40 per tagli fino a 40 mm nel lavoro di tutti i giorni: pignone maggiorato e batterie più leggere; EVO 3 se vuoi il top di gamma, con margine fino a 42 mm.",
      );
  } else {
    if (a.tipoAsta === "fissa" && a.modalita !== "senza")
      scelta(
        "potatore_fisso",
        a.estensione === "massima" ? ["skycut", "cs10"] : ["cs10", "skycut"],
        a.estensione === "massima"
          ? "Skycut 315, perché vuoi la maggiore estensione: lavori da terra con l’asta fissa più lunga."
          : "CS-10: il potatore con l’asta fissa per lavorare da terra, nella configurazione standard.",
      );
    else if (hobby || semi) {
      if (d <= 120)
        scelta(
          "potatore_semi",
          hobby ? ["cs1se", "cs1"] : ["cs1", "cs1se"],
          "CS-1 SE e CS-1 condividono il corpo macchina: cambia la dotazione di batterie. La capacità indicativa è rispettivamente 12 e 13 cm.",
        );
      else if (d <= 130)
        scelta(
          "potatore_semi13",
          ["cs1", "cs26"],
          "CS-1 copre fino a 13 cm indicativi; CS-2 da 6 pollici è l’alternativa professionale.",
        );
      else
        scelta(
          "potatore_upgrade",
          ["cs28", "xpro"],
          "CS-2 da 8 pollici: il diametro supera i 13 cm dei CS-1, serve un potatore con più capacità (fino a 19 cm indicativi).",
        );
    } else if (a.imprevedibile && d <= 200)
      scelta(
        "potatore_imprevedibile",
        ["xpro", "cs28"],
        "X-PRO per diametri diversi e imprevedibili: basamento porta barra in acciaio, doppia barra e velocità catena di 12 m/s.",
      );
    else if (d <= 130)
      scelta(
        "potatore_compatto",
        ["cs26", "xpro"],
        "CS-2 da 6 pollici per potatura professionale con priorità alla maneggevolezza e al poco ingombro.",
      );
    else
      scelta(
        "potatore_grande",
        ["cs28", "xpro"],
        "CS-2 da 8 pollici per capacità indicativa fino a 19 cm.",
      );
  }
  let ammessi = ids.filter((id) => {
    const problemi = vincoli(id, a);
    const eccezione = regola === "frutteto42_occasionali" && id === "evo3";
    return (
      problemi.filter((p) => !(eccezione && p.startsWith("La capacità")))
        .length === 0
    );
  });
  if (catalogo.length)
    ammessi = ammessi.filter((id) =>
      catalogo.some((p) => p.handle === modelli[id] && p.attivo !== false),
    );
  if (!ammessi.length)
    return {
      stato: "consulenza",
      versione: VERSION,
      regola,
      richiesta:
        "Nessuno dei modelli di questo percorso copre tutti i requisiti indicati.",
      esclusi: ids.map((id) => ({ id, motivi: vincoli(id, a) })),
    };
  if (ammessi[0] !== ids[0]) {
    const frasi = {
      "La capacità": "non arriva al diametro che hai indicato",
      "Non è un modello con asta fissa": "non ha l’asta fissa",
      "Non compatibile con asta smontabile": "non si monta sull’asta",
      "Modello con asta fissa": "ha l’asta fissa, mentre tu lavori anche senza",
      "Non alimentabile tramite cavo": "non si alimenta con il cavo",
    };
    const perche = vincoli(ids[0], a).map(
      (v) => Object.entries(frasi).find(([k]) => v.startsWith(k))?.[1] || v,
    );
    motivo =
      nomiModelli[ammessi[0]] +
      ", perché " +
      nomiModelli[ids[0]] +
      ", che per il resto sarebbe la prima scelta, " +
      perche.join(" e ") +
      ".";
  }
  if (a.famiglia === "forbici" && a.movimento === "sincronizzato" && g !== "ulivo" && d < 35 && regola !== "asta_fissa")
    avvertenze.push(
      "Entrambe le lame mobili le ha solo la SW-768, che è una 42 mm: per tagli fino a " + d + " mm ti consigliamo una forbice della tua misura.",
    );
  // Potatore con e senza asta: l'X-PRO non va su asta, quindi resterebbe una
  // proposta sola. Si affianca l'altro CS-2 (Jacopo, 10/10/2026), se arriva al diametro.
  if (a.famiglia === "potatori" && a.modalita === "entrambe" && ammessi.length === 1) {
    const altro = { cs1: "cs26", cs26: "cs28", cs28: "cs26" }[ammessi[0]];
    if (altro && !vincoli(altro, a).length) ammessi.push(altro);
  }
  // Un consiglio ha sempre un modello da confrontare, tranne la SW-921 (Jacopo, 10/10/2026: «a parte
  // sw921 tutti gli altri hanno un modello superiore da paragonare»). Se il percorso ne lascia uno solo,
  // si affianca il gradino sopra della stessa linea, purche' rispetti le risposte; altrimenti quello dopo.
  // CS-2 8": l'X-PRO non va su asta, quindi chi lavora con l'asta ha accanto il CS-2 6" (Jacopo, 10/10).
  if (ammessi.length === 1 && ammessi[0] !== "sw921") {
    const conAsta = a.modalita && a.modalita !== "senza";
    const sopra = {
      sw718: "hobby40", pru28: "pru30", hobby40: "pro8605", pru30: "pru36", pru36: "pru40",
      cs1se: "cs1", cs1: "cs26", cs26: "cs28", cs28: conAsta ? "cs26" : "xpro",
    };
    for (let id = sopra[ammessi[0]], giri = 0; id && giri < 3; id = sopra[id], giri++)
      if (!ammessi.includes(id) && !vincoli(id, a).length) { ammessi.push(id); break; }
  }
  for (const id of ammessi)
    if (cable && ["pru30", "sw8608"].includes(id))
      avvertenze.push(
        "Per " + nomiModelli[id] + " il cavo va acquistato a parte.",
      );
  if (secondariaUsata)
    avvertenze.push(
      "La priorità principale che hai indicato non cambia la scelta tra questi modelli: abbiamo tenuto conto della seconda, «" +
        ETICHETTE_PRIORITA[secondariaUsata] +
        "».",
    );
  return {
    stato: "consiglio",
    versione: VERSION,
    regola,
    principaleId: ammessi[0],
    principale: modelli[ammessi[0]],
    alternative: ammessi.slice(1).map((id) => modelli[id]),
    alternativeId: ammessi.slice(1),
    motivazione: motivo,
    avvertenze,
    secondariaUsata,
    compatibili: compatibili(ammessi[0]),
    macroCategorie: [...new Set(a.colture.map(gruppoColtura))],
  };
}
function valutaProdotto(id, a, catalogo = []) {
  const consiglio = consiglia(a, catalogo);
  const problemi = ["raccolta", "legatura"].includes(a.famiglia)
    ? []
    : vincoli(id, a);
  if (consiglio.stato !== "consiglio")
    return { esito: "da_precisare", consiglio, problemi };
  if (problemi.length) {
    if (
      id === "evo3" &&
      consiglio.regola === "frutteto42_occasionali" &&
      problemi.length === 1
    )
      return { esito: "adatto_con_limite", consiglio, problemi };
    return { esito: "non_adatto", consiglio, problemi };
  }
  if (consiglio.principaleId === id)
    return { esito: "adatto", consiglio, problemi: [] };
  return {
    esito: "alternativa_consigliata",
    consiglio,
    problemi: [],
    motivazione:
      "Il modello copre i requisiti tecnici indicati, ma il consiglio tiene conto anche di coltura, utilizzo e priorità.",
  };
}

const options = (key, label, labels, values, extra = {}) => ({
  key,
  label,
  options: labels.map((label, i) => ({ label, value: values?.[i] ?? label })),
  ...extra,
});
function domandePer(a, { prodotto = false, handle = null } = {}) {
  const s = [];
  if (!prodotto)
    s.push(
      options(
        "famiglia",
        "Per quale lavorazione cerchi un consiglio?",
        domande.lavorazione,
        ["forbici", "potatori", "legatura", "raccolta"],
      ),
    );
  s.push(
    options(
      "colture",
      "Su quali colture lavori?",
      a.famiglia === "raccolta" ? ["Uliveto"] : colture,
      null,
      { multi: true },
    ),
  );
  if (a.colture?.length > 1)
    s.push(
      options(
        "prevalente",
        "Su quale coltura lavori prevalentemente?",
        a.colture,
      ),
    );
  if (!a.famiglia) return s;
  if (gruppoColtura(a.prevalente || a.colture?.[0]) === "tenero")
    s.push(
      options(
        "tipoLegnoTenero",
        "Quale contesto descrive meglio il lavoro?",
        [
          "Tagli simili alla potatura di meli e peri",
          "Tagli simili alla potatura del vigneto",
        ],
        ["frutteto", "vigneto"],
      ),
    );
  if (a.famiglia === "legatura") {
    s.push({
      key: "diametroLegatura",
      label: "Qual è il diametro complessivo di ramo e sostegno da legare?",
      number: true,
      unit: "mm",
      min: 1,
      max: 100,
    });
    return s;
  }
  const olive = gruppoColtura(a.prevalente || a.colture?.[0]) === "ulivo";
  if (a.famiglia === "raccolta") {
    s.push(
      options(
        "livello",
        "Per quale utilizzo cerchi l’abbacchiatore?",
        ["Uliveto personale", "Semiprofessionale", "Professionale e intensivo"],
        ["hobby", "semi", "pro"],
      ),
    );
    s.push(
      options(
        "alimentazioneRaccolta",
        "Quale alimentazione preferisci?",
        [
          "Batteria a terra e cavo",
          "Batteria nello zaino",
          "Nessuna preferenza",
        ],
        ["terra", "zaino", "nessuna"],
      ),
    );
    return s;
  }
  const forbice = a.famiglia === "forbici";
  s.push(
    options(
      "intervento",
      "Quale lavoro esegui principalmente?",
      forbice
        ? [
            "Pulizia di polloni e succhioni",
            "Potatura verde e rifinitura",
            "Potatura ordinaria",
            "Potatura intensiva",
          ]
        : [
            "Potatura e sramatura",
            "Diametri diversi e imprevedibili",
            "Sezionamento delle ramaglie",
          ],
      forbice
        ? ["pulizia", "verde", "ordinaria", "intensa"]
        : ["sramatura", "variabili", "ramaglie"],
    ),
  );
  s.push(
    options(
      "livello",
      forbice
        ? "Per quale utilizzo cerchi la forbice?"
        : "Per quale utilizzo cerchi il potatore?",
      forbice
        ? olive
          ? domande.usoUlivo
          : domande.uso
        : [
            "Interventi occasionali",
            "Utilizzo regolare durante la stagione",
            "Professionale",
            "Professionale intensivo",
          ],
      forbice
        ? olive
          ? ["hobby", "semi500", "semi1000", "pro"]
          : ["hobby", "semi", "pro", "intensivo"]
        : ["occasionale", "regolare", "pro", "intensivo"],
    ),
  );
  s.push(
    options(
      "fascia",
      "Quali diametri hai bisogno di tagliare?",
      forbice ? domande.diametroForbici : domande.diametroPotatori,
      forbice
        ? ["lt30", "30_35", "35_40", "40_45"]
        : ["lt100", "100_150", "variabili"],
    ),
  );
  if (forbice && a.fascia === "lt30")
    s.push(
      options(
        "diametro",
        "I tagli rientrano entro 28 mm?",
        ["Sì, entro 28 mm", "Mi serve arrivare a 30 mm"],
        [28, 30],
      ),
    );
  // 35-40 mm: chi taglia al massimo 36 mm ha nella PRU-36 la forbice giusta,
  // che con la fascia arrotondata a 40 restava sempre fuori. Si chiede solo
  // dove cambia il consiglio (non in uliveto e su legno duro, dove si parte
  // comunque da 40 mm).
  const gruppo = (() => {
    const gr = gruppoColtura(a.prevalente || a.colture?.[0]);
    return gr === "tenero" ? a.tipoLegnoTenero : gr;
  })();
  if (forbice && a.fascia === "35_40" && !["ulivo", "duro"].includes(gruppo))
    s.push(
      options(
        "diametro",
        "Il taglio più grosso arriva a 36 mm o va oltre?",
        ["Fino a 36 mm", "Oltre 36 e fino a 40 mm"],
        [36, 40],
      ),
    );
  if (forbice && a.fascia === "40_45") {
    s.push(
      options(
        "diametro",
        "Quale apertura massima ti serve?",
        ["Fino a 42 mm", "Fino a 45 mm"],
        [42, 45],
      ),
    );
    if (a.diametro === 45 && !olive)
      s.push(
        options(
          "oltre42",
          "I tagli oltre 42 mm sono frequenti oppure occasionali?",
          ["Frequenti", "Occasionali"],
          ["frequenti", "occasionali"],
        ),
      );
  }
  if (!forbice && a.fascia === "100_150")
    s.push(
      options(
        "diametro",
        "Quale diametro massimo devi coprire?",
        ["Fino a 12 cm", "Fino a 13 cm", "Fino a 15 cm"],
        [120, 130, 150],
      ),
    );
  if (!forbice && a.fascia === "variabili")
    s.push(
      options(
        "diametro",
        "Quale diametro massimo ti serve?",
        ["Fino a 18 cm", "Fino a 19 cm", "Fino a 20 cm", "Oltre 20 cm"],
        [180, 190, 200, 210],
      ),
    );
  s.push(
    options(
      "modalita",
      "Come devi lavorare?",
      forbice
        ? [
            "Solo forbice, senza asta",
            "Con asta",
            "Sia senza asta sia con asta",
          ]
        : [
            "Solo potatore a catena, senza asta",
            "Con asta",
            "Sia senza asta sia con asta",
          ],
      ["senza", "solo_asta", "entrambe"],
    ),
  );
  if (a.modalita === "solo_asta")
    s.push(
      options(
        "tipoAsta",
        "Quale asta cerchi?",
        forbice
          ? ["Asta smontabile", "Asta fissa"]
          : ["Asta smontabile", "Asta fissa — sramatore da terra"],
        ["smontabile", "fissa"],
      ),
    );
  if (!forbice && a.tipoAsta === "fissa" && a.modalita === "solo_asta")
    s.push(
      options(
        "estensione",
        "Qual è la tua priorità per il lavoro in quota?",
        ["Configurazione standard", "Maggiore estensione"],
        ["standard", "massima"],
      ),
    );
  s.push(
    options(
      "prioritaPrincipale",
      "Qual è la tua priorità principale?",
      domande.priorita.concat(
        "Corpo compatto e accorciato",
        "Nessuna preferenza",
      ),
      [
        "peso",
        "velocita",
        "robustezza",
        "capacita",
        "top",
        "compattezza",
        "nessuna",
      ],
    ),
  );
  if (!prodotto && a.prioritaPrincipale && a.prioritaPrincipale !== "nessuna")
    s.push(
      options(
        "prioritaSecondaria",
        "Vuoi indicare una seconda priorità?",
        domande.priorita.concat("Nessuna"),
        ["peso", "velocita", "robustezza", "capacita", "top", "nessuna"],
      ),
    );
  // La seconda priorita' non puo' ripetere la prima: si toglie qui, non solo
  // nell'interfaccia, cosi' nessun percorso arriva al motore incompleto.
  const sec = s.find((x) => x.key === "prioritaSecondaria");
  if (sec)
    sec.options = sec.options.filter((o) => o.value !== a.prioritaPrincipale);
  if (forbice)
    s.push(
      options(
        "alimentazione",
        "Quale alimentazione preferisci?",
        domande.alimentazione,
        ["batteria", "cavo", "entrambe", "nessuna"],
      ),
    );
  if (
    forbice &&
    !olive &&
    (!prodotto || handle === "forbici-swansoft-sw-768-42mm")
  )
    s.push(
      options(
        "movimento",
        "Hai una preferenza per il movimento di taglio?",
        [
          "Movimento tradizionale / nessuna preferenza",
          "Entrambe le lame mobili",
        ],
        ["tradizionale", "sincronizzato"],
      ),
    );
  return s;
}
function risposteNormalizzate(a) {
  const b = {
    ...a,
    imprevedibile: a.fascia === "variabili" || a.intervento === "variabili",
  };
  if (a.famiglia === "forbici" && a.fascia === "30_35") b.diametro = 35;
  if (
    a.famiglia === "forbici" &&
    a.fascia === "35_40" &&
    b.diametro === undefined
  )
    b.diametro = 40;
  if (a.famiglia === "potatori" && a.fascia === "lt100") b.diametro = 100;
  if (a.modalita === "entrambe") b.tipoAsta = "smontabile";
  if (a.modalita === "senza") delete b.tipoAsta;
  return b;
}

function aggiornaRisposta(a, key, value) {
  const ordine = [
    "famiglia",
    "colture",
    "prevalente",
    "tipoLegnoTenero",
    "diametroLegatura",
    "intervento",
    "livello",
    "alimentazioneRaccolta",
    "fascia",
    "diametro",
    "oltre42",
    "modalita",
    "tipoAsta",
    "estensione",
    "prioritaPrincipale",
    "prioritaSecondaria",
    "alimentazione",
    "movimento",
  ];
  const index = ordine.indexOf(key);
  if (index < 0) throw new Error("Domanda sconosciuta");
  for (const later of ordine.slice(index + 1)) delete a[later];
  a[key] = value;
  return a;
}

// Le risposte in un link, solo codici (mai nome o email): servono alla pagina
// /pages/selezione, che rifa' il consiglio con lo stesso motore, e alle email.
const CODICI = {
  famiglia: "f",
  colture: "c",
  prevalente: "p",
  tipoLegnoTenero: "t",
  diametroLegatura: "g",
  intervento: "i",
  livello: "u",
  alimentazioneRaccolta: "r",
  fascia: "s",
  diametro: "d",
  oltre42: "o",
  modalita: "m",
  tipoAsta: "a",
  estensione: "e",
  prioritaPrincipale: "q",
  prioritaSecondaria: "q2",
  alimentazione: "b",
  movimento: "v",
};
const slugColtura = (c) =>
  c
    .toLowerCase()
    .replace(/ — /g, "-")
    .replace(/altra coltura-legno di /, "altra-")
    .replace(/altra coltura-legno /, "altra-")
    .replace(/ e manutenzione del verde/, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
const daSlug = (s) => colture.find((c) => slugColtura(c) === s);
function codiciSelezione(a) {
  const q = new URLSearchParams();
  for (const [k, c] of Object.entries(CODICI)) {
    const v = a[k];
    if (v === undefined || v === null || v === "") continue;
    if (k === "colture") q.set(c, v.map(slugColtura).join("."));
    else if (k === "prevalente") q.set(c, slugColtura(v));
    else q.set(c, String(v));
  }
  return q.toString();
}
function daCodici(stringa) {
  const q = new URLSearchParams(stringa);
  const a = { colture: [] };
  for (const k of [
    "famiglia",
    "colture",
    "prevalente",
    "tipoLegnoTenero",
    "diametroLegatura",
    "intervento",
    "livello",
    "alimentazioneRaccolta",
    "fascia",
    "diametro",
    "oltre42",
    "modalita",
    "tipoAsta",
    "estensione",
    "prioritaPrincipale",
    "prioritaSecondaria",
    "alimentazione",
    "movimento",
  ]) {
    const v = q.get(CODICI[k]);
    if (v === null) continue;
    if (k === "colture") a.colture = v.split(".").map(daSlug).filter(Boolean);
    else if (k === "prevalente") a.prevalente = daSlug(v);
    else if (["diametro", "diametroLegatura"].includes(k)) a[k] = Number(v);
    else a[k] = v;
  }
  return a;
}

const profiliEmail = {
  sw718: [
    "Pulizia hobbistica e rifinitura in giardino.",
    "se cerchi una forbice piccola per pulizia e rifinitura occasionale, senza asta e senza cavo.",
  ],
  hobby40: [
    "La forbice hobbistica per la potatura varia.",
    "se fai potatura hobbistica e ti serve un’apertura fino a 40 mm, oltre ai piccoli lavori di pulizia.",
  ],
  pru28: [
    "Pulizia professionale di polloni e succhioni.",
    "se fai tagli sottili ripetuti e vuoi una forbice di supporto specifica per la pulizia; non monta asta e non funziona via cavo.",
  ],
  pru30: [
    "Compatta e veloce per il vigneto.",
    "se privilegi velocità e poco ingombro nei tagli ripetuti fino a 30 mm. Per alimentarla via cavo, il cavo va acquistato separatamente.",
  ],
  titan30: [
    "Leggerezza per il lavoro nel vigneto.",
    "se il minor peso è la tua priorità e lavori fino a 30 mm, senza cavo e senza asta.",
  ],
  sw8608: [
    "La 35 mm semiprofessionale e versatile.",
    "se cerchi una forbice semiprofessionale per tagli fino a 35 mm su diverse colture. Il cavo, se richiesto, si acquista separatamente.",
  ],
  pru36: [
    "La professionale intermedia per diverse colture.",
    "se cerchi una forbice professionale equilibrata e versatile per passare da una coltura all’altra, con apertura fino a 36 mm.",
  ],
  evo1: [
    "Il top di gamma da 35 mm, leggera e potente.",
    "se cerchi la serie top di gamma entro 35 mm, con potenza e peso ottimizzati per tagli ripetuti.",
  ],
  pro8605: [
    "Semiprofessionale per oliveti fino a 500 piante.",
    "se gestisci un oliveto fino a 500 piante con uso semiprofessionale e tagli entro 40 mm.",
  ],
  sw758: [
    "Più reattività nella fascia semiprofessionale.",
    "se resti nella fascia semiprofessionale e privilegi la reattività, anche per oliveti fino a 1.000 piante.",
  ],
  pru40: [
    "La professionale per la potatura continuativa dell’ulivo.",
    "se cerchi una professionale pronta e veloce per la potatura continuativa dell’ulivo: è il nostro riferimento per questo utilizzo.",
  ],
  titan40: [
    "Peso contenuto e meccanica rinforzata.",
    "se dai più importanza al minor peso e alla robustezza della meccanica interna, mantenendo la stessa capacità di taglio della PRU-40.",
  ],
  evo2: [
    "Il top di gamma compatto da 40 mm.",
    "se cerchi una 40 mm della serie EVO, con corpo accorciato, alleggerito e struttura insonorizzata.",
  ],
  evo3: [
    "Il top di gamma intermedio tra 40 e 45 mm.",
    "se cerchi un’intermedia tra 40 e 45 mm: EVO 3 arriva a 42 mm ed è pensata per tagli impegnativi e uso intensivo.",
  ],
  sw768: [
    "Un diverso movimento di taglio, fino a 42 mm.",
    "se preferisci espressamente una forbice con entrambe le lame mobili: una sola lama tagliente e un taglio pronto, fino a 42 mm.",
  ],
  plus45: [
    "Reattività e maggiore apertura, fino a 45 mm.",
    "se ti servono tutti i 45 mm di apertura, anche per i tagli in cui una 40 o una 42 non basta; tra le 45 è quella che privilegia la reattività.",
  ],
  titan45: [
    "La 45 mm con corpo accorciato e pignone maggiorato.",
    "se ti serve l’apertura da 45 mm e privilegi il corpo accorciato e la costruzione con pignone maggiorato.",
  ],
  sw921: [
    "La forbice con asta fissa.",
    "se cerchi espressamente una forbice con asta fissa, anziché una forbice utilizzabile anche senza asta.",
  ],
  cs1se: [
    "Potatura occasionale, fino a 12 cm indicativi.",
    "se cerchi un potatore per uso occasionale entro 12 cm. Il corpo macchina è quello del CS-1, ma cambiano le batterie e non monta su asta.",
  ],
  cs1: [
    "Potatura regolare, fino a 13 cm indicativi.",
    "se cerchi il corpo compatto della serie CS-1 con la diversa dotazione di batterie e la possibilità di montarlo su asta smontabile.",
  ],
  cs26: [
    "Poco ingombro nella potatura professionale.",
    "se lavori entro 13 cm indicativi e privilegi maneggevolezza e poco ingombro, anche con asta smontabile.",
  ],
  cs28: [
    "Maggiore capacità, fino a 19 cm indicativi.",
    "se ti serve maggiore capacità di taglio, fino a 19 cm indicativi, mantenendo la possibilità di montarlo su asta smontabile.",
  ],
  xpro: [
    "Prontezza per diametri diversi e imprevedibili.",
    "se lavori su diametri diversi e imprevedibili fino a 20 cm con la barra da 8 pollici: offre doppia barra, basamento porta barra in acciaio e velocità catena di 12 m/s. Non monta su asta.",
  ],
  cs10: [
    "Sramatore da terra con asta fissa.",
    "se cerchi un potatore su asta fissa per lavorare da terra, con capacità indicativa fino a 19 cm.",
  ],
  skycut: [
    "Sramatore da terra per maggiore estensione.",
    "se privilegi la maggiore estensione nel lavoro da terra con asta fissa e una capacità indicativa fino a 20 cm.",
  ],
  b12: [
    "Legatura entro 25 mm complessivi.",
    "se devi legare ramo e sostegno entro un diametro complessivo di 25 mm.",
  ],
  evo42: [
    "Raccolta con batteria a terra e cavo.",
    "se preferisci la batteria a terra e avanzare con il cavo: una soluzione adatta anche all’uso professionale quando scegli questa alimentazione.",
  ],
  evo42ultra: [
    "Raccolta con batteria nello zaino.",
    "se preferisci muoverti con la batteria nello zaino, anche in un oliveto personale.",
  ],
};
// Le voci scritte per l'uliveto e per il vigneto valgono solo li': PRU-40,
// SW-758 e 8605 Pro escono anche su legno duro e in giardino, PRU-30 anche
// nella pulizia con il cavo. Fuori dalla loro coltura parlano di misure.
const fuoriColtura = {
  pru40: [
    "La professionale da 40 mm per la potatura continuativa.",
    "se cerchi una professionale pronta e veloce per tagli fino a 40 mm nel lavoro di tutti i giorni; condivide le batterie con i potatori CS-2 e X-PRO.",
  ],
  sw758: [
    "Più reattività nella fascia semiprofessionale.",
    "se resti nella fascia semiprofessionale e privilegi la reattività, con tagli fino a 40 mm.",
  ],
  pro8605: [
    "La 40 mm semiprofessionale.",
    "se cerchi una semiprofessionale con apertura fino a 40 mm e vuoi spendere il giusto.",
  ],
  pru30: [
    "Compatta e veloce, fino a 30 mm.",
    "se privilegi velocità e poco ingombro nei tagli ripetuti fino a 30 mm. Per alimentarla via cavo, il cavo va acquistato separatamente.",
  ],
};
// Confronti alla pari approvati (gamma del 20/09/2026 e regole di ottobre):
// quando la coppia e' una di queste, il motivo dell'alternativa dice la
// differenza vera invece della frase generica.
const coppie = {
  "titan40>evo3":
    "La EVO 3 è il top di gamma: arriva a 42 mm, quindi ti lascia margine sopra i 40, ed è pensata per tagli impegnativi e uso intensivo.",
  "pru40>evo3":
    "La EVO 3 è il top di gamma: arriva a 42 mm, quindi ti lascia margine sopra i 40, ed è pensata per tagli impegnativi e uso intensivo.",
  "cs26>cs28":
    "Il CS-2 da 8 pollici è lo stesso potatore con la barra più lunga: arriva a 19 cm, con le stesse batterie e la stessa asta.",
  "cs28>cs26":
    "Il CS-2 da 6 pollici è lo stesso potatore con la barra più corta: più maneggevole, fino a 13 cm, con le stesse batterie e la stessa asta.",
  "pru40>evo2":
    "La EVO 2 ha la stessa apertura da 40 mm ed è il top di gamma: corpo compatto, accorciato e alleggerito, struttura insonorizzata.",
  "evo2>titan40":
    "La Titan 40 ha la stessa apertura da 40 mm, batterie più leggere e il pignone maggiorato: costa meno della EVO 2.",
  "pru30>sw8608":
    "La 8608 è la semiprofessionale da 35 mm: costa meno e taglia qualche millimetro in più, ma è meno veloce della PRU-30.",
  "pru40>titan40":
    "La Titan 40 offre capacità di taglio e potenza sullo stesso livello della PRU-40. Si distingue per il pignone maggiorato, la costruzione interna rinforzata e il peso più contenuto.",
  "titan40>pru40":
    "La PRU-40 mantiene la stessa fascia professionale, con capacità di taglio e livello di potenza comparabili. È il riferimento Gardenmac per chi privilegia la prontezza nella potatura continuativa.",
  "evo2>pru40":
    "La PRU-40 ha la stessa apertura da 40 mm ed è la professionale più scelta; in più condivide le batterie con i potatori CS-2 e X-PRO.",
  "pru30>titan30":
    "La Titan 30 lavora nella stessa fascia da 30 mm ed è la più leggera; non si alimenta con il cavo e non va su asta.",
  "titan30>pru30":
    "La PRU-30 lavora nella stessa fascia da 30 mm ed è la più veloce; si alimenta anche con il cavo, acquistato a parte.",
  "evo1>pru36":
    "La PRU-36 è la professionale intermedia classica e versatile, con apertura fino a 36 mm: la scegli se passi spesso da una coltura all’altra.",
  "pru36>evo1":
    "La EVO 1 è il top di gamma entro 35 mm: più leggera e più potente, con un millimetro di apertura in meno.",
  "pro8605>sw758":
    "La SW-758 resta nella fascia semiprofessionale da 40 mm ed è più reattiva della 8605 Pro.",
  "sw758>pro8605":
    "La 8605 Pro è la semiprofessionale da 40 mm più accessibile, pensata per oliveti fino a 500 piante.",
  "plus45>titan45":
    "La Titan 45 ha la stessa apertura da 45 mm, con il corpo accorciato e il pignone maggiorato.",
  "titan45>plus45":
    "La PRU-45 PLUS ha la stessa apertura da 45 mm e privilegia la reattività.",
  "cs28>xpro":
    "L’X-PRO ha una costruzione diversa: doppia barra e basamento porta barra in acciaio, pensata per diametri diversi e imprevedibili, fino a 20 cm con la barra da 8 pollici. Non si monta su asta.",
  "xpro>cs28":
    "Il CS-2 da 8 pollici arriva a 19 cm e si monta sull’asta smontabile; condivide le batterie con l’X-PRO.",
  "cs26>xpro":
    "L’X-PRO ha doppia barra e basamento porta barra in acciaio, per diametri diversi e imprevedibili, fino a 20 cm con la barra da 8 pollici. Non si monta su asta.",
  "cs1>cs26":
    "Il CS-2 da 6 pollici è il passo verso il professionale: batterie da 21 V, le stesse delle forbici da 40 mm.",
  "cs1>cs1se":
    "Il CS-1 SE è la stessa macchina con batterie più piccole: costa meno, ma non si monta su asta.",
  "cs1se>cs1":
    "Il CS-1 è la stessa macchina con batterie più capienti, arriva a 13 cm e si monta sull’asta.",
  "cs10>skycut":
    "Lo Skycut 315 ha l’asta fissa più lunga e più potenza (800 W contro 600): lo scegli se devi arrivare più in alto.",
  "skycut>cs10":
    "Il CS-10 ha l’asta fissa più corta e costa meno: basta se non devi arrivare oltre i 270 cm.",
  "sw758>pru40":
    "La PRU-40 è il passo al professionale: stessa apertura da 40 mm, pensata per la potatura di tutti i giorni.",
  "pru40>sw758":
    "La SW-758 resta nella fascia semiprofessionale, con la stessa apertura da 40 mm e un prezzo più basso.",
  "sw8608>pru36":
    "La PRU-36 è la professionale intermedia: un millimetro in più di apertura e pensata per lavorare tutti i giorni.",
  "pru36>sw8608":
    "La 8608 è la semiprofessionale da 35 mm: costa meno ed è leggera.",
  "sw8608>pru30":
    "La PRU-30 è la professionale del vigneto: la più veloce del catalogo, fino a 30 mm.",
  "evo3>plus45":
    "La PRU-45 PLUS arriva a 45 mm: copre anche i tagli che superano i 42 mm della EVO 3.",
  "evo42>evo42ultra":
    "EVO 42 Ultra ha le stesse velocità e funzioni: cambia solo l’alimentazione, con la batteria nello zaino.",
  "evo42ultra>evo42":
    "EVO 42 ha le stesse velocità e funzioni: cambia solo l’alimentazione, con la batteria a terra e il cavo.",
};
function editorialeConsiglio(result, answers, immagini = {}) {
  const id = result.principaleId,
    alt = result.alternativeId?.[0];
  const gruppi = (answers.colture || []).map(gruppoColtura);
  const profilo = (k) =>
    (k === "pru30"
      ? !answers.colture?.includes("Vigneto") &&
        answers.tipoLegnoTenero !== "vigneto"
      : !gruppi.includes("ulivo")) && fuoriColtura[k]
      ? fuoriColtura[k]
      : profiliEmail[k];
  const p = profilo(id);
  if (!p) throw new Error("Profilo editoriale mancante: " + id);
  const modalita = {
    senza: "Utilizzo senza asta",
    solo_asta:
      answers.tipoAsta === "fissa" ? "Con asta fissa" : "Con asta smontabile",
    entrambe: "Senza asta e con asta smontabile",
  };
  const dettagli = [
    answers.famiglia === "legatura" && answers.diametroLegatura
      ? "Legatura fino a " +
        answers.diametroLegatura +
        " mm tra ramo e sostegno"
      : null,
    answers.diametro
      ? answers.famiglia === "potatori"
        ? "Rami fino a " + answers.diametro / 10 + " cm"
        : "Tagli fino a " + answers.diametro + " mm"
      : null,
    modalita[answers.modalita],
  ].filter(Boolean);
  const groups = {};
  for (const x of result.compatibili || []) {
    const key =
      x.id === "sw921"
        ? "Svettatoio"
        : x.famiglia === "forbici"
          ? "Forbici"
          : x.famiglia === "potatori"
            ? "Potatori"
            : "Legatrice";
    (groups[key] ??= []).push(nomiModelli[x.id]);
  }
  const out = {
    introduzione:
      "In base alle colture, all’utilizzo e alle preferenze che hai indicato, ti consigliamo " +
      nomiModelli[id] +
      ".",
    sottotitolo: p[0],
    riepilogo_taglio: dettagli.join(" · "),
    modello_immagine: immagini[id] || "",
    compatibilita_gruppi: Object.entries(groups).map(([famiglia, modelli]) => ({
      famiglia,
      modelli: modelli.join(", "),
    })),
  };
  if (alt) {
    const q = profilo(alt);
    if (!q) throw new Error("Alternativa editoriale mancante: " + alt);
    Object.assign(out, {
      alternativa_nome: nomiModelli[alt],
      alternativa_motivo:
        nomiModelli[alt] + ": " + q[0].charAt(0).toLowerCase() + q[0].slice(1),
      scelta_principale: p[1],
      scelta_alternativa: q[1],
    });
    if (coppie[id + ">" + alt]) out.alternativa_motivo = coppie[id + ">" + alt];
    if (result.regola === "movimento_sincronizzato")
      out.alternativa_motivo =
        "Se il movimento tradizionale ti va bene, " +
        nomiModelli[alt] +
        " è la scelta che ti avremmo dato per lo stesso lavoro. " +
        q[0];
  }
  return out;
}

const immaginiEmail = {
  sw718:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/SW-718-2.png?v=1789143462",
  hobby40:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/860540MM-2.png?v=1789143454",
  pru28:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/PRU-28-3.png?v=1789143453",
  pru30:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/PRU-30-2.png?v=1789143463",
  titan30:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/TITAN30.png?v=1789143473",
  sw8608:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/860835MM-2.png?v=1789143455",
  pru36:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/PRU-36-5.png?v=1789143458",
  evo1: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/EVO1-2.png?v=1789143468",
  pro8605:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/8605PRO40MM.png?v=1789143454",
  sw758:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/SW-758.png?v=1789143464",
  pru40:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/PRU-40-2.png?v=1789143453",
  titan40:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/TITAN40.png?v=1789143458",
  evo2: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/EVO2.png?v=1789143468",
  evo3: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/EVO3.png?v=1789143473",
  sw768:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/SW-768.png?v=1789143463",
  plus45:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/PRU-45PLUS-2.png?v=1789143458",
  titan45:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/TITAN45.png?v=1789143477",
  sw921:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/SW-921.png?v=1789143467",
  cs1se:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/CS-1-SE-6.png?v=1789142782",
  cs1: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/CS-1_6-2.png?v=1789143458",
  cs26: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/CS-26.png?v=1789143473",
  cs28: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/CS-28-27.png?v=1789143462",
  xpro: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/X-PRO6_8.png?v=1789143468",
  cs10: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/CS-108.png?v=1789143467",
  skycut:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/SKYCUT315.png?v=1789143475",
  b12: "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/legatrice-swb12-gardenmac.png?v=1789148038",
  evo42:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/falco-evo42-cavo-inverter.jpg?v=1790871564",
  evo42ultra:
    "https://cdn.shopify.com/s/files/1/0837/8351/6502/files/falco-evo42-ultra-zaino-cavo.jpg?v=1790871564",
};

// Linea commerciale dai tag dei prodotti (letti il 10/10/2026). Le macchine su
// asta, la legatrice e gli abbacchiatori non hanno un tag di linea: restano vuote.
const LINEA = {
  sw718: "hobbistica",
  hobby40: "hobbistica",
  pro8605: "semi-professionale",
  sw8608: "semi-professionale",
  sw758: "semi-professionale",
  cs1: "semi-professionale",
  cs1se: "semi-professionale",
  pru28: "professionale",
  pru30: "professionale",
  pru36: "professionale",
  pru40: "professionale",
  plus45: "professionale",
  sw768: "professionale",
  titan30: "professionale",
  titan40: "professionale",
  titan45: "professionale",
  cs26: "professionale",
  cs28: "professionale",
  xpro: "professionale",
  evo1: "top di gamma",
  evo2: "top di gamma",
  evo3: "top di gamma",
};
const KLAVIYO = {
  company: "TwuRbR",
  revision: "2026-07-15",
  metric: "Gardenmac Consiglio Richiesto",
  enabled: true,
};
function preparaRichiesta({
  email,
  answers,
  source = "configurator",
  productHandle = null,
  requestId,
  marketingConsent = false,
  prezzi = {},
  lingua = "it",
  traduci = null,
}) {
  email = typeof email === "string" ? email.trim() : "";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || ""))
    throw new Error("Email non valida");
  if (!requestId || typeof requestId !== "string")
    throw new Error("Identificativo richiesta mancante");
  const result = consiglia(answers);
  if (result.stato !== "consiglio")
    throw new Error("Il consiglio richiede una verifica");
  const link = (id) => "https://gardenmac.com/products/" + modelli[id];
  const labels = {
    hobby: "Hobbistico",
    semi: "Semiprofessionale",
    semi500: "Semiprofessionale fino a 500 piante",
    semi1000: "Semiprofessionale fino a 1.000 piante",
    pro: "Professionale",
    intensivo: "Professionale intensivo",
    occasionale: "Interventi occasionali",
    regolare: "Utilizzo regolare durante la stagione",
  };
  const properties = {
    versione_regole: VERSION,
    richiesta_id: requestId,
    origine:
      source === "product"
        ? "scheda:" + (productHandle || "")
        : source === "home"
          ? "home"
          : "configuratore",
    prodotto_visitato: productHandle || "",
    famiglia: answers.famiglia,
    colture: answers.colture,
    colture_testo: answers.colture.join(", "),
    coltura_prevalente: answers.prevalente || answers.colture[0],
    uso: answers.livello || "legatura",
    uso_testo:
      answers.famiglia === "raccolta"
        ? {
            hobby: "Uliveto personale",
            semi: "Semiprofessionale",
            pro: "Professionale e intensivo",
          }[answers.livello]
        : labels[answers.livello] || "Legatura",
    diametro_mm: answers.diametro || answers.diametroLegatura || null,
    modalita: answers.modalita || null,
    tipo_asta: answers.tipoAsta || null,
    alimentazione:
      answers.alimentazione || answers.alimentazioneRaccolta || null,
    priorita_principale: answers.prioritaPrincipale || "nessuna",
    priorita_secondaria: answers.prioritaSecondaria || "nessuna",
    modello_id: result.principaleId,
    modello_nome: nomiModelli[result.principaleId],
    modello_handle: result.principale,
    motivazione: result.motivazione,
    regola: result.regola,
    landing_url: link(result.principaleId),
    avvertenze: result.avvertenze || [],
    alternative: (result.alternativeId || []).map((id) => ({
      nome: nomiModelli[id],
      url: link(id),
    })),
    compatibili: (result.compatibili || []).map((p) => ({
      nome: nomiModelli[p.id],
      famiglia: p.famiglia,
      url: link(p.id),
    })),
    marketing_richiesto: marketingConsent === true,
    consenso_marketing: marketingConsent === true,
    famiglia_testo: {
      forbici: "forbici",
      potatori: "potatori",
      raccolta: "abbacchiatori",
      legatura: "legatrici",
    }[answers.famiglia],
    linea: LINEA[result.principaleId] || "",
    selezione_url:
      "https://gardenmac.com/pages/la-tua-scelta?" + codiciSelezione(answers),
    leva: ETICHETTE_PRIORITA[answers.prioritaPrincipale] || "",
    test: false,
    invio_abilitato: 1,
  };
  Object.assign(
    properties,
    editorialeConsiglio(result, answers, immaginiEmail),
  );
  properties.modello_immagine_url = properties.modello_immagine || "";
  if (result.alternativeId?.[0]) {
    properties.alternativa_url = link(result.alternativeId[0]);
    properties.alternativa_handle = modelli[result.alternativeId[0]];
    properties.alternativa_id = result.alternativeId[0];
  }
  if (prezzi[result.principaleId])
    properties.modello_prezzo = prezzi[result.principaleId];
  if (result.alternativeId?.[0] && prezzi[result.alternativeId[0]])
    properties.alternativa_prezzo = prezzi[result.alternativeId[0]];
  // Lingua della pagina (10/10/2026). I campi qui sopra restano in italiano,
  // perche' segmenti e flussi li leggono per valore; i testi da mettere nella
  // lettera, nella lingua del cliente, stanno in testi_lingua.
  properties.lingua = lingua || "it";
  if (traduci && properties.lingua !== "it") {
    const pre = "https://gardenmac.com/" + properties.lingua + "/";
    const loc = (u) => (u ? u.replace("https://gardenmac.com/", pre) : u);
    const t = (x) => (typeof x === "string" ? traduci(x) : x);
    properties.testi_lingua = {
      modello_nome: t(properties.modello_nome),
      alternativa_nome: t(properties.alternativa_nome || ""),
      motivazione: t(properties.motivazione),
      alternativa_motivo: t(properties.alternativa_motivo || ""),
      scelta_principale: t(properties.scelta_principale || ""),
      scelta_alternativa: t(properties.scelta_alternativa || ""),
      avvertenze: (properties.avvertenze || []).map(t),
      colture_testo: answers.colture.map(t).join(", "),
      uso_testo: t(properties.uso_testo),
      sottotitolo: t(properties.sottotitolo || ""),
      compatibilita_gruppi: (properties.compatibilita_gruppi || []).map((g) => ({ famiglia: t(g.famiglia.toLowerCase()), modelli: t(g.modelli) })),
      landing_url: loc(properties.landing_url),
      alternativa_url: loc(properties.alternativa_url || ""),
      selezione_url: loc(properties.selezione_url),
    };
  }
  const profileProperties = {
    GM_famiglia: properties.famiglia,
    GM_colture: properties.colture,
    GM_coltura_prevalente: properties.coltura_prevalente,
    GM_uso: properties.uso,
    GM_modello_consigliato: properties.modello_id,
    GM_versione_regole: VERSION,
    // Gli stessi nomi che il configuratore scrive nel profilo dal 18/09/2026:
    // segmenti e flussi esistenti li leggono gia'. Valori sempre in italiano.
    Coltura: properties.coltura_prevalente,
    "Diametro ramo": properties.diametro_mm || "",
    Uso: properties.uso_testo,
    "Modello consigliato": properties.modello_nome,
    "Modello consigliato URL": properties.landing_url,
    "Alternativa consigliata": properties.alternativa_nome || "",
    "Alternativa URL": properties.alternativa_url || "",
    "Leva di scelta": properties.leva,
    "Modello consigliato prezzo": properties.modello_prezzo ?? "",
    "Alternativa prezzo": properties.alternativa_prezzo ?? "",
    Lingua: properties.lingua,
    Origine: source === "product" ? "Test prodotto" : source === "home" ? "Home" : "Configuratore",
  };
  return {
    data: {
      type: "event",
      attributes: {
        unique_id: requestId,
        metric: {
          data: { type: "metric", attributes: { name: KLAVIYO.metric } },
        },
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email.trim().toLowerCase(),
              properties: profileProperties,
            },
          },
        },
        properties,
      },
    },
  };
}
async function inviaConsiglio(
  input,
  {
    fetcher = globalThis.fetch,
    enabled = KLAVIYO.enabled,
    timeoutMs = 15000,
  } = {},
) {
  if (!enabled) throw new Error("Invio non attivato");
  const body = preparaRichiesta(input);
  const post = async (url, options) => {
    const controller = new AbortController();
    let timer;
    try {
      return await Promise.race([
        fetcher(url, { ...options, signal: controller.signal }),
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            controller.abort();
            reject(new Error("Tempo di invio scaduto"));
          }, timeoutMs);
        }),
      ]);
    } finally {
      clearTimeout(timer);
    }
  };
  const response = await post(
    "https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO.company,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json",
        revision: KLAVIYO.revision,
      },
      body: JSON.stringify(body),
    },
  );
  if (response.status !== 202) throw new Error("Richiesta non accettata");
  let marketingAccepted = null;
  if (input.marketingConsent === true) {
    const subscription = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Gardenmac configuratore — consenso facoltativo",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: input.email.trim().toLowerCase(),
                subscriptions: {
                  email: { marketing: { consent: "SUBSCRIBED" } },
                },
              },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: "TZsH63" } } },
      },
    };
    try {
      const sub = await post(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" +
          KLAVIYO.company,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: KLAVIYO.revision,
          },
          body: JSON.stringify(subscription),
        },
      );
      marketingAccepted = sub.status === 202;
    } catch {
      marketingAccepted = false;
    }
  }
  return {
    accepted: true,
    requestId: input.requestId,
    marketingRequested: input.marketingConsent === true,
    marketingAccepted,
  };
}

/* Interfaccia del configuratore (pagina /pages/configuratore) e del test «fa
   per te?» in fondo alle schede. Usa SOLO il motore (regole + percorso):
   domande, consiglio, alternativa, testi e invio vengono da li'.
   La grafica e' quella della guida in home (gm-guida): righe bianche su fondo
   grigio, barra blu con il pallino, pulsanti blu a raggio 10, niente card nelle
   domande. Il consiglio si vede SUBITO sul sito (regola del 18/09/2026: il
   risultato non si nasconde dietro l'email); l'email serve a portarselo a casa,
   il consenso alle promozioni e' una casella a parte e non spuntata. */
const RADICE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
const FRECCIA =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const SPUNTA =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
/* Lingue (10/10/2026): i testi restano scritti in italiano nel motore e si
   traducono qui, cercando la frase intera nel dizionario della lingua della
   pagina (assets/gm-advice-<lingua>.js, generato da crea-bundle.py). Una frase
   che manca resta in italiano. Fuori dall'Italia: niente telefono fisso e niente
   abbacchiatori (non si spediscono). L'email si chiede in tutte le lingue dal
   10/10/2026: il gestionale manda la lettera nella lingua dell'evento. */
const LINGUA = String(document.documentElement.lang || "it").slice(0, 2).toLowerCase();
const ESTERO = LINGUA !== "it";
// Il dizionario si legge a ogni chiamata: se arriva dopo il motore, vale lo stesso.
const DIZ = () => (window.GM_ADVICE_I18N && window.GM_ADVICE_I18N[LINGUA]) || {};
function T(s, v) {
  let x = (typeof s === "string" && DIZ()[s]) || s;
  if (v && typeof x === "string") for (const k in v) x = x.split("{" + k + "}").join(v[k]);
  return x;
}
// I soli nomi di modello che contengono parole italiane.
const NOMI_LINGUA = {
  "CS-2 da 6 pollici": { en: "CS-2 6-inch", es: "CS-2 de 6 pulgadas", fr: "CS-2 6 pouces", de: "CS-2 6 Zoll", pl: "CS-2 6 cali" },
  "CS-2 da 8 pollici": { en: "CS-2 8-inch", es: "CS-2 de 8 pulgadas", fr: "CS-2 8 pouces", de: "CS-2 8 Zoll", pl: "CS-2 8 cali" },
};
function nomeLingua(t) {
  if (!ESTERO || typeof t !== "string") return t;
  for (const [it, tr] of Object.entries(NOMI_LINGUA)) if (tr[LINGUA]) t = t.split(it).join(tr[LINGUA]);
  return t;
}
const VALUTA = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
const soldi = (c) => {
  try {
    return (c / 100).toLocaleString(LINGUA === "en" ? "en-GB" : LINGUA, { style: "currency", currency: VALUTA, minimumFractionDigits: 0, maximumFractionDigits: 2 });
  } catch (e) {
    return (c / 100).toFixed(2) + " " + VALUTA;
  }
};

const schede = {};
function scheda(id) {
  if (!schede[id])
    schede[id] = fetch(RADICE + "products/" + modelli[id] + ".js", { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        if (!p) return null;
        const v = p.variants.find((x) => x.available) || p.variants[0];
        let img = p.featured_image || "";
        if (img.startsWith("//")) img = "https:" + img;
        if (img) img += (img.includes("?") ? "&" : "?") + "width=420";
        return {
          titolo: p.title, prezzo: p.price, url: RADICE + "products/" + p.handle, img,
          variante: v && v.id, varianteNome: p.variants.length > 1 && v ? v.title : "", disponibile: p.available,
        };
      })
      .catch(() => null);
  return schede[id];
}
async function nelCarrello(id) {
  const p = await scheda(id);
  if (!p || !p.variante) throw new Error("variante");
  try {
    const mod = await import("cart-store");
    if (mod && mod.default && mod.default.add) {
      await mod.default.add({ id: p.variante, quantity: 1 });
      return;
    }
  } catch (e) {}
  const r = await fetch(RADICE + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: p.variante, quantity: 1 }] }),
  });
  if (!r.ok) throw new Error("carrello");
}

function monta(root, { handle = null, mode = "product", preview = true, privacy = "", contatti = "", emailPrima = false, origine = "" } = {}) {
  if (root.dataset.gmMounted === "true") return;
  root.dataset.gmMounted = "true";
  const corrente = Object.keys(modelli).find((k) => modelli[k] === handle);
  // Abbacchiatori: solo Italia, all'estero il test in scheda non compare.
  if (mode === "product" && ESTERO && ["evo42", "evo42ultra"].includes(corrente)) {
    (root.closest(".gmqp-test") || root).hidden = true;
    return;
  }
  if (mode === "product" && !corrente) {
    (root.closest(".gmqp-sezione") || root).hidden = true;
    return;
  }
  const famiglia =
    (prodotti[corrente] && prodotti[corrente].famiglia) ||
    (corrente === "b12" ? "legatura" : ["evo42", "evo42ultra"].includes(corrente) ? "raccolta" : null);
  // Su SW-921 il test parte da «forbici con asta fissa»: e' una forbice, ma su asta.
  let a = { ...(famiglia ? { famiglia } : {}), colture: [] };
  let indice = 0;
  let richiesta = null, impronta = null, inVolo = false;
  // Home (Jacopo, 10/10/2026): l'email si chiede PRIMA del risultato, «a quale
  // email te lo inviamo?»; poi il consiglio si vede anche sul sito.
  let inviataA = null, ultimaEmail = "";
  root.classList.add("gmqp");

  const el = (tag, cls, testo) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (testo != null) n.textContent = T(testo);
    return n;
  };
  const nomeDi = (id) => nomeLingua(nomiModelli[id] || id);
  const passi = () => domandePer(a, { prodotto: mode === "product", handle });

  function vaiA(i) {
    indice = Math.max(0, i);
    disegna(true);
  }

  function disegna(conFuoco) {
    root.replaceChildren();
    const elenco = passi();
    if (indice >= elenco.length) return esito();
    const passo = elenco[indice];

    const barra = el("div", "gmqp__passi");
    barra.innerHTML = '<span class="gmqp__barra"><span class="gmqp__fatto"><i class="gmqp__pallino"></i></span></span>';
    const pct = Math.round((indice / (elenco.length + 1)) * 100);
    barra.querySelector(".gmqp__fatto").style.width = Math.max(4, pct) + "%";
    barra.setAttribute("role", "progressbar");
    barra.setAttribute("aria-valuemin", "0");
    barra.setAttribute("aria-valuemax", "100");
    barra.setAttribute("aria-valuenow", String(pct));
    barra.setAttribute("aria-label", T("Avanzamento del test"));
    root.append(barra);

    const titolo = el("h3", "gmqp__chiede", passo.label);
    titolo.tabIndex = -1;
    titolo.id = "gmqp-q-" + Math.random().toString(36).slice(2, 8);
    root.append(titolo);
    if (passo.multi) root.append(el("p", "gmqp__aiuto", "Puoi sceglierne più di una."));

    const gruppo = el("div", "gmqp__scelte" + (passo.multi ? " gmqp__scelte--multi" : ""));
    gruppo.setAttribute("role", "group");
    gruppo.setAttribute("aria-labelledby", titolo.id);
    root.append(gruppo);

    if (passo.number) {
      const lab = el("label", "gmqp__numero");
      const inp = el("input");
      inp.type = "number"; inp.inputMode = "numeric"; inp.min = passo.min; inp.max = passo.max; inp.step = 1;
      inp.value = a[passo.key] || "";
      inp.setAttribute("aria-label", T(passo.label) + " (" + passo.unit + ")");
      lab.append(inp, el("span", "gmqp__unita", passo.unit));
      gruppo.append(lab);
      const avanti = el("button", "gmqp__btn", "Continua");
      avanti.type = "button";
      const ok = () => Number(inp.value) >= passo.min && Number(inp.value) <= passo.max;
      avanti.disabled = !ok();
      inp.addEventListener("input", () => (avanti.disabled = !ok()));
      avanti.addEventListener("click", () => {
        aggiornaRisposta(a, passo.key, Number(inp.value));
        vaiA(indice + 1);
      });
      { const az = el("div", "gmqp__azioni"); az.append(avanti); root.append(az); }
    } else {
      const opzioni = passo.options.filter(
        (o) => (passo.key !== "prioritaSecondaria" || o.value !== a.prioritaPrincipale) && !(ESTERO && passo.key === "famiglia" && o.value === "raccolta"),
      );
      for (const o of opzioni) {
        const attivo = passo.multi ? (a[passo.key] || []).includes(o.value) : a[passo.key] === o.value;
        const b = el("button", "gmqp__scelta" + (passo.multi ? " gmqp__scelta--spunta" : ""));
        b.type = "button";
        b.setAttribute("aria-pressed", attivo ? "true" : "false");
        b.innerHTML = passo.multi
          ? '<span class="gmqp__casella" aria-hidden="true">' + SPUNTA + "</span>"
          : "";
        b.append(el("span", "gmqp__scelta-nome", o.label));
        if (!passo.multi) b.insertAdjacentHTML("beforeend", FRECCIA);
        b.addEventListener("click", () => {
          if (passo.multi) {
            const prima = a[passo.key] || [];
            aggiornaRisposta(a, passo.key, prima.includes(o.value) ? prima.filter((x) => x !== o.value) : [...prima, o.value]);
            disegna(false);
            const stesso = [...root.querySelectorAll(".gmqp__scelta")].find((x) => x.textContent === T(o.label));
            if (stesso) stesso.focus();
          } else {
            aggiornaRisposta(a, passo.key, o.value);
            vaiA(indice + 1);
          }
        });
        gruppo.append(b);
      }
      if (passo.multi) {
        const avanti = el("button", "gmqp__btn", "Continua");
        avanti.type = "button";
        avanti.disabled = !(a[passo.key] || []).length;
        avanti.addEventListener("click", () => vaiA(indice + 1));
        { const az = el("div", "gmqp__azioni"); az.append(avanti); root.append(az); }
      }
    }
    if (indice > 0) {
      const p = el("p", "gmqp__indietro");
      const b = el("button", "gmqp__link", "← Domanda precedente");
      b.type = "button";
      b.addEventListener("click", () => vaiA(indice - 1));
      p.append(b);
      root.append(p);
    }
    if (conFuoco) titolo.focus({ preventScroll: true });
    if (conFuoco && root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: "start", behavior: "auto" });
  }

  function piede(conRifai = true) {
    const p = el("p", "gmqp__daccapo");
    if (conRifai) {
      const r = el("button", "gmqp__ricomincia", "Rifai il test");
      r.type = "button";
      r.addEventListener("click", () => {
        a = { ...(famiglia ? { famiglia } : {}), colture: [] };
        inviataA = null;
        vaiA(0);
      });
      p.append(r);
    }
    const c = el("button", "gmqp__link", "Cambia una risposta");
    c.type = "button";
    c.addEventListener("click", () => { inviataA = null; vaiA(passi().length - 1); });
    p.append(c);
    return p;
  }

  function contattiBox() {
    const box = el("div", "gmqp__contatti");
    box.innerHTML = ESTERO
      ? '<a class="gmqp__btn" href="https://wa.me/393770859705" target="_blank" rel="noopener"></a>' +
        '<a class="gmqp__btn gmqp__btn--vuoto" href="mailto:assistenza@gardenmac.com"></a>'
      : '<a class="gmqp__btn" href="tel:+390865860247">Chiama 0865 860247</a>' +
        '<a class="gmqp__btn gmqp__btn--vuoto" href="https://wa.me/393770859705" target="_blank" rel="noopener">Scrivi su WhatsApp</a>';
    if (ESTERO) {
      box.children[0].textContent = T("Scrivi su WhatsApp");
      box.children[1].textContent = T("Scrivi ad assistenza@gardenmac.com");
    }
    return box;
  }

  async function esito() {
    const risposte = risposteNormalizzate(a);
    const r = consiglia(risposte);
    if (r.stato !== "consiglio") {
      root.append(
        el("h3", "gmqp__esito-titolo", r.stato === "fuori_gamma" ? "Questo lavoro va oltre i nostri modelli" : "Per consigliarti bene ci serve una parola in più"),
        el("p", "gmqp__testo", r.richiesta || "Scrivici o chiamaci: ti rispondiamo noi."),
        contattiBox(),
        piede(),
      );
      return;
    }
    const ed = editorialeConsiglio(r, risposte, typeof immaginiEmail !== "undefined" ? immaginiEmail : {});
    const alt = r.alternativeId && r.alternativeId[0];
    if (emailPrima && !inviataA) return cancello(r, risposte, [r.principaleId, alt].filter(Boolean));
    const titolo = el("h3", "gmqp__esito-titolo");
    titolo.tabIndex = -1;

    if (mode === "product") {
      const v = valutaProdotto(corrente, risposte);
      const io = nomeDi(corrente);
      const testi = {
        adatto: ["si", T("Sì: {io} fa per il tuo lavoro.", { io })],
        adatto_con_limite: ["limite", T("{io} va bene, con un limite da sapere.", { io })],
        alternativa_consigliata: ["quasi", T("{io} può andare, ma per il tuo lavoro c'è una scelta più adatta.", { io })],
        non_adatto: ["no", T("{io} non è la scelta giusta per il tuo lavoro.", { io })],
      }[v.esito] || ["quasi", T("Ecco cosa ti consigliamo")];
      titolo.textContent = testi[1];
      root.append(titolo);
      if (v.esito === "non_adatto" && v.problemi.length) {
        const frasi = {
          "La capacità": "non arriva al diametro che hai indicato",
          "Non è un modello con asta fissa": "non ha l'asta fissa",
          "Non compatibile con asta smontabile": "non si monta sull'asta",
          "Modello con asta fissa": "ha l'asta fissa, mentre tu lavori anche senza",
          "Non alimentabile tramite cavo": "non si alimenta con il cavo",
          "Famiglia diversa": "è un'altra famiglia di attrezzi",
        };
        const perche = v.problemi.map((p) => T((Object.entries(frasi).find(([k]) => p.startsWith(k)) || [0, p])[1]));
        root.append(el("p", "gmqp__testo", T("Il motivo: {io} {perche}.", { io, perche: perche.join(T(" e ")) })));
      }
    } else {
      titolo.textContent = T("Ecco il modello giusto per il tuo lavoro");
      root.append(titolo);
    }

    const griglia = el("div", "gmqp__schede");
    root.append(griglia);
    const proposte = [r.principaleId, alt].filter(Boolean);
    const cards = proposte.map((id, i) => {
      const c = el("article", "gmqp__scheda" + (i ? " gmqp__scheda--alt" : ""));
      c.append(el("span", "gmqp__tag", i ? "L'alternativa" : mode === "product" && id === corrente ? "Questo modello" : "Il nostro consiglio"));
      const testa = el("div", "gmqp__testa");
      const foto = el("div", "gmqp__foto");
      const tes = el("div");
      tes.append(el("p", "gmqp__nome", nomeDi(id)));
      const linea = el("p", "gmqp__linea", "");
      tes.append(linea);
      testa.append(foto, tes);
      c.append(testa);
      // Il nome e' gia' il titolo della scheda: «PRU-40: il riferimento…» diventa «Il riferimento…».
      const senzaNome = (t) => {
        const n = nomeDi(id);
        if (!t || !t.startsWith(n + ":")) return t || "";
        const r = t.slice(n.length + 1).trim();
        return r.charAt(0).toUpperCase() + r.slice(1);
      };
      c.append(el("p", "gmqp__motivo", senzaNome(nomeLingua(T(i ? ed.alternativa_motivo : r.motivazione)))));
      const acquisto = el("div", "gmqp__acquisto");
      const prezzo = el("p", "gmqp__prezzo", "");
      const azioni = el("div", "gmqp__bottoni");
      const compra = el("button", "gmqp__btn" + (i ? " gmqp__btn--vuoto" : ""), "Aggiungi al carrello");
      compra.type = "button";
      const vedi = el("a", "gmqp__vedi", "Vedi la scheda");
      vedi.href = RADICE + "products/" + modelli[id];
      if (mode === "product" && id === corrente) vedi.hidden = true;
      compra.addEventListener("click", async () => {
        compra.disabled = true;
        const prima = compra.textContent;
        compra.textContent = T("Aggiungo…");
        try {
          await nelCarrello(id);
          compra.innerHTML = SPUNTA + "<span></span>";
          compra.lastChild.textContent = T("Nel carrello");
          compra.classList.add("gmqp__btn--fatto");
          const vai = el("a", "gmqp__vedi", "Vai al carrello");
          vai.href = RADICE + "cart";
          vedi.replaceWith(vai);
        } catch (e) {
          compra.disabled = false;
          compra.textContent = prima;
          prezzo.append(el("span", "gmqp__errore", "Non è andata, riprova."));
        }
      });
      azioni.append(compra, vedi);
      acquisto.append(prezzo, azioni);
      c.append(acquisto);
      griglia.append(c);
      scheda(id).then((p) => {
        if (!p) return;
        if (p.img) {
          const im = el("img");
          im.src = p.img; im.alt = ""; im.loading = "lazy"; im.width = 210; im.height = 210;
          foto.append(im);
        }
        prezzo.textContent = soldi(p.prezzo);
        if (p.varianteNome) prezzo.append(el("span", "gmqp__variante", p.varianteNome));
        if (!p.disponibile) { compra.disabled = true; compra.textContent = T("Non disponibile"); }
      });
      return c;
    });
    (r.avvertenze || []).forEach((t) => root.append(el("p", "gmqp__nota", t)));

    if (alt && ed.scelta_principale) {
      const coda = el("div", "gmqp__coda");
      coda.append(el("p", "gmqp__coda-titolo", T("Come scegliere fra {a} e {b}", { a: nomeDi(r.principaleId), b: nomeDi(alt) })));
      for (const [id, testo] of [[r.principaleId, ed.scelta_principale], [alt, ed.scelta_alternativa]]) {
        const p = el("p", "gmqp__scegli");
        p.append(el("span", "gmqp__scegli-nome", T("Scegli {nome}", { nome: nomeDi(id) })), document.createTextNode(T(testo)));
        coda.append(p);
      }
      root.append(coda);
    }
    if (ed.compatibilita_gruppi && ed.compatibilita_gruppi.length) {
      const g = ed.compatibilita_gruppi.map((x) => `${nomeLingua(x.modelli.replace(/ · /g, ", "))} (${T(x.famiglia.toLowerCase())})`);
      const elenco = g.length < 2 ? g[0] : g.slice(0, -1).join(", ") + T(" e ") + g.at(-1);
      root.append(el("p", "gmqp__batterie", T("Con le batterie di {nome} lavori anche con {elenco}.", { nome: nomeDi(r.principaleId), elenco })));
    }
    // Scheda prodotto: il consiglio e basta, nessuna email (Jacopo, 10/10/2026).
    // L'email si chiede solo nel configuratore (home e /pages/configuratore).
    if (emailPrima && inviataA) {
      const ok = el("p", "gmqp__nota gmqp__nota--ok");
      ok.textContent = preview
        ? "Anteprima: qui il consiglio partirebbe per email a " + inviataA + ". Nessuna email è stata inviata."
        : T("Te l'abbiamo mandato anche a {email}. Se non lo trovi fra qualche minuto, guarda in Promozioni o nello Spam.", { email: inviataA });
      titolo.after(ok);
    } else if (mode !== "product") root.append(modulo(r, risposte, proposte));
    root.append(piede());
    titolo.focus({ preventScroll: true });
    if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: "start", behavior: "auto" });
  }

  function cancello(r, risposte, proposte) {
    const barra = el("div", "gmqp__passi");
    barra.innerHTML = '<span class="gmqp__barra"><span class="gmqp__fatto" style="width:100%"><i class="gmqp__pallino"></i></span></span>';
    root.append(barra, modulo(r, risposte, proposte, true));
    const p = el("p", "gmqp__indietro");
    const b = el("button", "gmqp__link", "← Domanda precedente");
    b.type = "button";
    b.addEventListener("click", () => vaiA(passi().length - 1));
    p.append(b);
    root.append(p);
    const h = root.querySelector(".gmqp__chiede");
    if (h) h.focus({ preventScroll: true });
    if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: "start", behavior: "auto" });
  }

  function modulo(r, risposte, proposte, prima = false) {
    const box = el("div", prima ? "gmqp__mail gmqp__mail--prima" : "gmqp__mail");
    if (prima) {
      const h = el("h3", "gmqp__chiede", "A quale email ti mandiamo il consiglio?");
      h.tabIndex = -1;
      box.append(h, el("p", "gmqp__mail-sub", "Ti scriviamo il modello giusto per il tuo lavoro, l’alternativa e come scegliere fra le due. Se hai un dubbio, rispondi alla mail: ti risponde una persona."));
    } else
      box.append(
        el("p", "gmqp__mail-tit", "Te lo mando anche per email?"),
        el("p", "gmqp__mail-sub", "Il consiglio, il confronto e i link alle schede. Se hai un dubbio, rispondi alla mail: ti risponde una persona."),
      );
    const form = el("form", "gmqp__mail-form");
    form.noValidate = true;
    const campo = el("input", "gmqp__mail-campo");
    campo.type = "email"; campo.name = "email"; campo.autocomplete = "email"; campo.required = true;
    campo.placeholder = T("La tua email");
    campo.setAttribute("aria-label", T("La tua email"));
    const etichetta = T(prima ? "Ricevi il consiglio" : "Mandamelo");
    const invia = el("button", "gmqp__btn", etichetta);
    if (ultimaEmail) campo.value = ultimaEmail;
    invia.type = "submit";
    const riga = el("div", "gmqp__mail-riga");
    riga.append(campo, invia);
    const consenso = el("label", "gmqp__consenso");
    const spunta = el("input");
    spunta.type = "checkbox"; spunta.name = "marketing"; spunta.checked = false;
    consenso.append(spunta, el("span", null, "Voglio ricevere anche consigli di stagione e offerte di Gardenmac. Facoltativo: puoi cancellarti quando vuoi."));
    const nota = el("p", "gmqp__privacy");
    nota.append(document.createTextNode(T("Usiamo l'email per mandarti questo consiglio. ")));
    const link = el("a", null, "Informativa sulla privacy");
    link.href = privacy || RADICE + "pages/tutela-della-privacy";
    nota.append(link, document.createTextNode("."));
    const stato = el("p", "gmqp__mail-esito");
    stato.setAttribute("role", "status");
    form.append(riga, consenso, nota, stato);
    box.append(form);

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const email = campo.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        stato.textContent = T("Controlla l'indirizzo email.");
        campo.focus();
        return;
      }
      ultimaEmail = email;
      if (preview) {
        if (prima) { inviataA = email; return vaiA(999); }
        stato.textContent = "Anteprima: l'invio non è ancora attivo, nessun indirizzo è stato registrato.";
        return;
      }
      if (inVolo) return;
      const firma = JSON.stringify([email.toLowerCase(), risposte, spunta.checked]);
      if (firma !== impronta) {
        richiesta = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        impronta = firma;
      }
      inVolo = true;
      invia.disabled = true;
      invia.textContent = T("Invio…");
      try {
        const prezzi = {};
        for (const id of proposte) {
          const p = await scheda(id);
          if (p) prezzi[id] = p.prezzo / 100;
        }
        const esito = await inviaConsiglio(
          { requestId: richiesta, email, marketingConsent: spunta.checked, answers: risposte, source: origine || mode, productHandle: handle, prezzi, lingua: LINGUA, traduci: (x) => nomeLingua(T(x)) },
          { enabled: true },
        );
        if (prima) {
          inviataA = email;
          vaiA(999);
          if (esito.marketingAccepted === false) root.querySelector(".gmqp__nota--ok")?.append(T(" L'iscrizione alle novità non è andata: riprova più tardi."));
          return;
        }
        form.replaceChildren(
          el("p", "gmqp__mail-ok", "Ottimo, controlla la tua email."),
          el("p", "gmqp__mail-sub", "Se non la trovi fra qualche minuto, guarda anche in Promozioni o nello Spam."),
        );
        if (esito.marketingAccepted === false)
          form.append(el("p", "gmqp__mail-sub", "Il consiglio è partito, ma l'iscrizione alle novità non è andata: riprova più tardi dal fondo della pagina."));
      } catch (err) {
        stato.textContent = T("Non è andata. Riprova fra poco, oppure scrivici ad assistenza@gardenmac.com.");
        invia.disabled = false;
        invia.textContent = etichetta;
      } finally {
        inVolo = false;
      }
    });
    return box;
  }

  // Arrivo da un link con le risposte (email, pagina selezione): si va dritti al consiglio.
  if (mode === "selezione" || (mode === "configurator" && location.search.includes("f="))) {
    const da = daCodici(location.search);
    if (da.famiglia && da.colture.length) {
      a = da;
      indice = 999;
      // Chi arriva dal link (la lettera, la pagina d'arrivo) l'email l'ha gia' data.
      emailPrima = false;
    }
    if (mode === "selezione") mode = "configurator";
  }
  disegna(false);
}

/* Per la pagina d'arrivo delle email (/pages/la-tua-scelta?<codici>, la costruisce
   la chat del mail marketing): dai codici del link restituisce lo stesso consiglio
   del configuratore, con gli stessi campi dell'evento Klaviyo (modello_handle,
   alternativa_handle, leva, motivazione, alternativa_motivo, scelta_principale,
   scelta_alternativa, avvertenze, colture_testo, uso_testo…). Se il motore non
   da' un consiglio: { stato, richiesta, risposte }. */
function risultato(stringa = location.search) {
  const a = risposteNormalizzate(daCodici(stringa));
  if (!a.famiglia || !a.colture.length) return { stato: "incompleto", richiesta: "", risposte: a };
  const r = consiglia(a);
  if (r.stato !== "consiglio") return { stato: r.stato, richiesta: r.richiesta || "", risposte: a };
  const p = preparaRichiesta({ email: "pagina@gardenmac.com", answers: a, requestId: "pagina", source: "landing" }).data.attributes.properties;
  return { ...p, stato: "consiglio", modello_id: r.principaleId, alternativa_id: (r.alternativeId || [])[0] || null, risposte: a };
}
/* Per il comparatore: profilo neutro (senza coltura) di un modello dato l'handle.
   sottotitolo = a chi serve in una riga, scelta = «se cerchi…» per «Scegli X se…». */
function profilo(h) {
  const id = Object.keys(modelli).find((k) => modelli[k] === h);
  if (!id) return null;
  const q = fuoriColtura[id] || profiliEmail[id];
  return q ? { id, nome: nomiModelli[id], sottotitolo: q[0], scelta: q[1] } : null;
}
/* Per la pagina d'arrivo /pages/la-tua-scelta (chat del mail marketing):
   - nelCarrello(id): aggiunge al carrello la variante disponibile del modello (id del
     motore, es. "pru40", gli stessi di risultato().modello_id / alternativa_id);
   - nomeLingua(testo): riscrive «CS-2 da 6/8 pollici» nella lingua della pagina;
   - testo(x): T + nomeLingua, cioe' quello che l'interfaccia mostra. */
const testo = (x, v) => nomeLingua(T(x, v));
window.GardenmacAdvice = { T, testo, nomeLingua, nelCarrello, lingua: LINGUA, risultato, profilo, mount: monta, consiglia, valutaProdotto, versione: VERSION, sendAdvice: inviaConsiglio };
function avvia(scope = document) {
  scope.querySelectorAll("[data-gm-advice-root]").forEach((root) =>
    monta(root, {
      handle: root.dataset.handle || null,
      mode: root.dataset.mode || "product",
      preview: root.dataset.preview !== "false",
      privacy: root.dataset.privacy || "",
      emailPrima: root.dataset.emailPrima === "true",
      origine: root.dataset.origine || "",
    }),
  );
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => avvia());
else avvia();
document.addEventListener("shopify:section:load", (e) => avvia(e.target));

})();
